import { Permissions } from 'shared/model/browser-permissions';

function getPermissionValue({
  permissionKey
}: {
  permissionKey: Permissions;
}): boolean {
  const params = new URLSearchParams(window.location.search);
  const disableList = params.get('disablePermissions');
  if (!disableList) return false;

  const disabled = disableList.split(',').map((p) => p.trim());

  return disabled.includes(permissionKey);
}

export { Permissions, getPermissionValue };
